import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Spinner from 'components/kea/placeholders/Spinner';
import { Clear, Search } from '@material-ui/icons';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const SearchInput = ({ changeHandler, isFiltering, value, onClear }) => {
  const localizeMessage = useLocalizedMessage();
  return (
    <TextField
      onChange={changeHandler}
      value={value}
      variant="outlined"
      size="small"
      placeholder={localizeMessage('catalog.product.search.placeholder')}
      inputProps={{ 'aria-label': localizeMessage('catalog.product.search.label') }}
      style={{ width: 'clamp(240px, 32vw, 440px)', maxWidth: '100%' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {isFiltering ? <Spinner r={15} /> : <Search fontSize="small" />}
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              aria-label={localizeMessage('catalog.product.search.clear')}
              onClick={onClear}
              size="small"
            >
              <Clear fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

SearchInput.propTypes = {
  changeHandler: PropTypes.func.isRequired,
  isFiltering: PropTypes.bool,
  value: PropTypes.string,
  onClear: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
  isFiltering: false,
  value: '',
};

export default SearchInput;
